// src/services/payfastPaymentService.js

import axios from "axios";

const apiUrl = process.env.VUE_APP_MICROSERVICE_API_URL;

export async function createPayfastOneTimePayment(name_first, name_last, email_address, cell_number, item_name, item_description, item_amount) {
    try {
        const payload =
        {
            "one_time_payment": true,
            "name_first": name_first,
            "name_last": name_last,
            "email_address": email_address,
            "cell_number": cell_number,
            "item_name": item_name,
            "item_description": item_description,
            "item_amount": item_amount
        }
        const response = await axios.post(`${apiUrl}/payments/create-payload`, payload);
        const callBody = response.data;
        return callBody;
    } catch (error) {
        console.error("Error fetching payment redirect:", error);
        throw error; // Rethrow the error for handling in components.
    }
}

export async function createPayfastSubscriptionPayment(name_first, name_last, email_address, cell_number, subscription_name, subscription_description, recurring_amount, first_billing_date, billing_frequency, number_cycles) {
    try {
        const response = await axios.post(`${apiUrl}/payments/create-payload`, {
            "one_time_payment": false,
            "name_first": name_first,
            "name_last": name_last,
            "email_address": email_address,
            "cell_number": cell_number,
            "subscription_name": subscription_name,
            "subscription_description": subscription_description,
            "first_billing_date": first_billing_date,
            "recurring_amount": recurring_amount,
            "billing_frequency": billing_frequency,
            "number_cycles": number_cycles
        });
        const callBody = response.data;
        return callBody;
    } catch (error) {
        console.error("Error fetching payment redirect:", error);
        throw error; // Rethrow the error for handling in components.
    }
}



